<script>
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	import PDFWalker from '../../PDFWalker.svelte';

	let div;

	onMount(() => {
		jumpByAnchor(div);
	});
</script>

<div bind:this={div} id="social-chain" class="page-special-social-chain marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Social Chain - Visualisierung - Desktop" src="./../img/16.Individuelle_Klasse/07.social_chain/visuals_1.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Social Chain - Visualisierung - mobile" src="./../img/16.Individuelle_Klasse/07.social_chain/mobile.webp">
			</div>
			<div class="flex element pdf">
				<PDFWalker pdfName="SOC_Flyer.pdf" height="849"/>
			</div>
		</div>

		<div class="flex row structure-2">
			<div class="flex col element text">
				<h2>{getText("16.07.01_h2")}</h2>
				<p class="caption">{getText("16.07.02_caption")}</p>
				<p class="caption">Kunde: Social Chain Berlin</p>
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Social Chain - Reporting-Tool" src="./../img/16.Individuelle_Klasse/07.social_chain/desktop.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	.page-special-social-chain {
		margin-top: $spacing-mobile-half;
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;

			.element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
			
			> .element:last-of-type {
				margin-bottom: 0;
			}
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			position: relative;
			align-content: flex-start;
			
			> .element:nth-of-type(1) {
				@include for-tablet-portrait-up {
					width: 55.5%;
				}
			}
			> .element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					width: 44.5%;
				}
			}
			
			> .element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					padding-left: $media-gap;
				}
			}
		}
		
		.structure-1,
		.structure-2 {
			@include for-tablet-portrait-up {
				width: 50%;
			}
		}
		
		.structure-2 {
			@include for-tablet-portrait-up {
				padding-left: $media-gap;
			}
		}
		
		.text {
			margin: 0;
		}

	}

	:global(.inner .page-special-social-chain .pdfwalker.marginbox) {
		margin: 0;
		width: 100%;
	}
</style>
